.modal-header {
    font-weight: 500;
    color: var(--grey-dk);
    font-size: var(--font-huge);
    line-height: 1.5;
    margin-bottom: 16px;
    width: calc(100% - 16px);
}
